export default "__VITE_ASSET__CAv1sOJ9__"